<style lang="sass">

    @import ../../common/styles/mixins

    @import ./informations

    .page-type-newsletter

        [role="contentinfo"]
            display: none


    .node-newsletter

        .block-breadcrumb
            padding-top: 6rem
            +media("<=1000px")
                padding-top: 5rem

        &__container
            +container2
            +media("<=desktop")
                padding: 0 4rem
            +media("<=900px")
                padding: 0
                margin: 0

            .node-newsletter__informations  &
                padding: 5rem 0
                +media("<=700px")
                    margin: 4rem 2rem
                    +media("<=900px")
                        margin-bottom: 0

        &__description
            line-height: 1.4
            margin: 4rem auto
            max-width: 56rem
            +media("<=900px")
                padding: 0 2rem

        &__types
            display: flex
            +media("<=900px")
                flex-direction: column

        &__type1
            flex-basis: 50%
            +media("<=900px")
                flex-basis: 100%
                .tab0 &
                    display: block
                .tab1 &
                    display: none

        &__type2
            flex-basis: 50%
            +media("<=900px")
                flex-basis: 100%
                .tab0 &
                    display: none
                .tab1 &
                    display: block

        &__toggle //Mobile
            display: none
            position: relative
            padding-bottom: 1rem
            border-bottom: 1px solid $color-text
            font-size: 0
            +media("<=900px")
                display: block
            &:after
                position: absolute
                content: ""
                width: 50%
                height: 4px
                bottom: 0
                left: 0
                background: $color-text
                transform: translateX(0%)
                transition: transform $speed-normal $authentic-motion-out

                .tab0 &
                    transform: translateX(0%)

                .tab1 &
                    transform: translateX(100%)

        &__select //Mobile
            width: 50%
            display: none
            flex-direction: column
            +media("<=900px")
                display: inline-block

        &__head
            +media("<=900px")
                display: none

        &__icon
            height: 6rem
            pointer-events: none
            +media("<=900px")
                height: 4rem
            svg
                height: 100%
                width: 100%

        &__title
            margin-bottom: 1rem
            margin-top: 0!important
            pointer-events: none
            +media("<=900px")
                margin-bottom: 0.5rem

        &__subtitle
            text-align: center
            font-size: 0.8rem

        &__item
            position: relative
            height: 10rem
            margin: 2rem 1rem
            box-sizing: border-box
            border: 1px solid $color-gray-medium
            display: flex
            justify-content: center
            flex-direction: column
            padding: 2rem
            transition: background $speed-normal $authentic-motion-out, border $speed-normal $authentic-motion-out
            cursor: pointer
            +media("<=900px")
                margin: 1rem
                padding: 1rem
                height: auto
                min-height: 10rem

            &:hover
                border: 1px solid $color-text

            &:after
                position: absolute
                content: ""
                width: 1.3rem
                height: 1.3rem
                top: 2rem
                right: 2rem
                background-image: url(../../common/graphics/check.svg)
                background-repeat: no-repeat
                background-size: contain

            &.active
                font-weight: bold
                background: $color-base
                border: 1px solid $color-base

        &__item-title
            font-size: 1.2rem
            font-weight: 600
            margin-bottom: 1rem
            font-family: Montserrat, sans-serif
            .active &
                color: #fff

        &__item-desc
            font-size: 1rem
            font-weight: 400
            line-height: 1.6
            .active &
                color: #fff

        &__actions
            text-align: center
            .button--red
                +media("<=tablet")
                    width: calc(100% - 2rem)

</style>


<script>

    import $ from "jquery"
    import { remove, clone, indexOf } from 'lodash/core'
    import {Bus as VuedalsBus} from "vuedals"
    import FormComponent from "./popin/FormComponent.vue"

    export default {

        data: () => ({
            newsletters: [],
            selectedTab: 'tab0'
        }),

        methods: {
            toggleType: function(type) {
                if ( this.hasType(type) ) {
                    remove(this.newsletters, (n) => n === type );
                    this.newsletters = clone(this.newsletters);
                } else
                    this.newsletters.push(type);
            },

            hasType: function(type) {
                return ( indexOf(this.newsletters, type) >= 0 );
            },

            openForm: function() {
                let that = this;
                VuedalsBus.$emit('new', {
                    name: 'newsletter-form',
                    component: FormComponent,
                    props: {
                        newsletters: this.newsletters
                    }
                });
            },

            selectTab(className) {
                this.selectedTab = className;
            },

            backToForm() {
                $(".page-type-newsletter form").submit();
            }
        },

        computed: {
            posted: function() {
                return ( $("#edit-type-part").length === 0 );
            }
        }

    }

</script>
